module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/1AoLjZSDUrjK8Ee2Gn6YzQ-585f1960351fe6824247e8bb736fb129.jpg";